import { render, staticRenderFns } from "./image-item.vue?vue&type=template&id=7bb8f54a&scoped=true"
import script from "./image-item.vue?vue&type=script&lang=js"
export * from "./image-item.vue?vue&type=script&lang=js"
import style0 from "./image-item.vue?vue&type=style&index=0&id=7bb8f54a&prod&lang=scss&scoped=true"
import style1 from "./image-item.vue?vue&type=style&index=1&id=7bb8f54a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb8f54a",
  null
  
)

export default component.exports